import { render } from "./SupplierList.vue?vue&type=template&id=0beac284&scoped=true"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"

import "./SupplierList.vue?vue&type=style&index=0&id=0beac284&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beac284"]])

export default __exports__